import React from 'react';
import { styled } from '@mui/material/styles';
import MuiTextField, { TextFieldProps } from '@mui/material/TextField';

type CustomTextFieldProps = TextFieldProps & {
  featureVariant?: 'A' | 'B'; // Feature flag for styling variant
};

const StyledTextField = styled(MuiTextField, {
})<CustomTextFieldProps>(({ theme, size, variant }) => ({
  ...(variant === 'filled' && {
    '&:hover': {
      '& .MuiFilledInput-root': {
        '&:before': {
          borderBottom: `2px solid ${ theme.palette.info.main }`,
        },
      },
    },
    '& .MuiFilledInput-root:not(:has(.MuiSelect-select))': {
      paddingLeft: '16px',
    },
    '& .MuiFilledInput-root': {
      backgroundColor: theme.palette.neutral.light,
      color: theme.palette.info.dark,
      '& .MuiInputAdornment-positionStart.MuiInputAdornment-root:not(.MuiInputAdornment-hiddenLabel)': {
        marginTop: 0,
      },
      '&.Mui-disabled': {
        backgroundColor: '#EDEEF2',
        '&:before': {
          borderBottom: `1px solid #a4a7b2`,
        },
        '& .MuiFilledInput-input, & .MuiInputBase-input': {
          color: '#574841 !important',
          'WebkitTextFillColor': 'unset',
        },
      },
    },
    '& .MuiInputLabel-root:not(.Mui-focused, .Mui-error):not(.MuiSelect-select)': {
      color: '#574841',
    },
    '& .MuiInputLabel-root:has(+ .MuiInputBase-adornedStart)': {
      transform: 'translate(48px, 16px) scale(1)',
      cursor: 'text',
      '&.Mui-focused, &.MuiFormLabel-filled': {
        transform: 'translate(48px, 8px) scale(0.75)',
        cursor: 'auto',
        color: '#9A918D',
      },
    },
  }),

  ...(size === 'small' && {
    alignSelf: 'stretch',
    '& .MuiInputLabel-root': {
      display: 'none',
    },
    '& .MuiInputBase-root': {
      padding: '0 8px',
      flexGrow: 1,
      '& .MuiInputAdornment-root': {
        marginTop: '0 !important',
      },
    },
    '& .MuiInputBase-input': {
      padding: 0,
      height: '32px',
      ...theme.typography.subtitle1,
    },
  }),
}));

// ✅ Forward the ref for React Hook Form + Chrome compatibility
export const TextFieldComponent = React.forwardRef<HTMLInputElement, CustomTextFieldProps>(
  function TextFieldComponent(props, ref) {
    return <StyledTextField { ...props } inputRef={ ref } />;
  },
);
